import { useContext } from 'react';

import { Context } from './context';

export const useShaxmatkaAction = () => useContext(Context);
